<template>
  <div>
    <ion-card>
      <ion-card-header>
        <ion-card-title :class="[' text--' + box.color]">{{ box.title }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ul>
          <li v-for="link in box.links" :key="link.id">
            <a :href="link.href" :class="['text--' + link.color]">{{ link.title }}</a>
          </li>
        </ul>
      </ion-card-content>
    </ion-card>
  </div>
</template>

<script>

  export default {
    name: "Box",
    props: ['box'],

  };
</script>

<style scoped>

  ul {
    font-size: 16px;
  }

  ion-card {
    --background: #3E4143;
    --color:  #B6B6B6;
    margin: 0;
  }
  ion-card-subtitle,
  ion-card-title {
    --color:  #B6B6B6;
  }

  ion-card-header {
    --background: #343638;
    border-bottom:  1px solid #adadad;
  }

  @media all and (display-mode: standalone), screen and (max-width: 768px) {
    ion-card {
      margin-bottom: 40px;
    }
  }
</style>
